import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { UtilService } from '../../../../services/util.service';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'form-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() label: string;
  @Input() placeholder: string;
  @ViewChild('picker') datePicker: MatDatepicker<Date>;
  public value: Date;
  public maxDate: Date;
  public minDate: Date;

  private _onChange = (_: any) => {};
  private _onTouch = () => {};

  constructor(private _utilService: UtilService) {
    this.value = null;
    this.maxDate = this._getMaxLimitDate();
    this.minDate = this._getMinLimitDate();
  }

  ngOnInit(): void {}

  onChange(event) {
    this.value = event.target.value;
    this._onTouch();
    this._onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value ? value : null;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  onOpen(){
    this.datePicker.open();
  }
  registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }

  private _getMaxLimitDate(): Date {
    const actualDate: Date = new Date();
    const actualYear: number = actualDate.getFullYear();
    const actualDay: number = actualDate.getDate();
    const actualMonth: number = actualDate.getMonth();

    let limitDate = actualYear;
    return new Date(limitDate, actualMonth, actualDay);
  }

  private _getMinLimitDate(): Date {
    const actualDate: Date = new Date();
    const actualYear: number = actualDate.getFullYear();

    let limitDate = actualYear - 120;
    return new Date(limitDate, 0, 1);
  }
}
